import React from "react";
import ParkingStickers from "../../../shared/parkings/ParkingStickers";
import { defaultCrewProps } from "../../../../libs/utils";

class RegistrationParkingStickers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    ...defaultCrewProps
  };

  render() {
    return <ParkingStickers admin registration={this.props.registration} />;
  }
}

export default RegistrationParkingStickers;
